import { plural } from '@srm/ui/lib/pluralize';

/**
 * «Человеческое» относительное время поступления для всплывающих превью уведомлений
 * у колокольчика: только что → N минут назад → N часов назад → N дней назад.
 * Обновляется на лету (см. тик в {@link NotificationToast}).
 *
 * @param fromMs метка времени поступления, мс (как `Date.now()`)
 * @param nowMs  текущее время, мс; по умолчанию `Date.now()`
 */
export function formatRelativeTime(fromMs: number, nowMs: number = Date.now()): string {
    const sec = Math.max(0, Math.floor((nowMs - fromMs) / 1000));
    if (sec < 45) return 'только что';

    const min = Math.floor((sec + 15) / 60);
    if (min <= 1) return 'минуту назад';
    if (min < 60) return `${min} ${plural(min, ['минуту', 'минуты', 'минут'])} назад`;

    const hour = Math.floor((min + 30) / 60);
    if (hour < 24) return hour <= 1 ? 'час назад' : `${hour} ${plural(hour, ['час', 'часа', 'часов'])} назад`;

    const day = Math.floor((hour + 12) / 24);
    return day <= 1 ? 'вчера' : `${day} ${plural(day, ['день', 'дня', 'дней'])} назад`;
}
